import React, { useState, useEffect } from "react";
import '../styles/other.css';
import '../styles/pages.css';
import Axios from 'axios';
import { Link, Navigate, useLocation } from "react-router-dom";
import { navigate } from "@reach/router";

// import utilities
import { checkForErrorsInRequest } from '../utilities/RequestsUtilities.js';

// import components
import RoundButton from '../components/RoundButton.js';
import ApplicationHistoryTile from '../tiles/ApplicationHistoryTile.js';
import ApplicationTile from '../tiles/ApplicationTile.js';

// import assets
import btn_back_gray from '../assets/btn_back_gray.png';
import background from '../assets/background.jpg';

class TaskDetail extends React.Component {
    setActualSection = this.props.setActualSection;

    constructor(props) {
        super(props);

        this.state = {
            redirectTo: null,
            mainTaskId: 0,
            /*taskData: ([]),*/
            note: "",
        }

    }

    componentDidMount(){
        this.setState({ redirectTo: null });

        const pathname = this.props.location.pathname;
        var id = pathname.substring(pathname.lastIndexOf("/")+1);
        if(id.includes("?")){ id = id.substring(0, id.indexOf("?")); }
        if(Number.isInteger(Number(id)))this.setState({ mainTaskId: parseInt(id) });
        
        //this.loadData();
    }

    componentDidUpdate(prevProps, prevState) {
    }

    loadData = () => {
        this.setState({ taskData: [] });

        var getOnlyMyContacts = this.props.allOrMy == "my" ? 1 : 0;
        var url = '/api/cont/get?tp=1&my='+getOnlyMyContacts;
        Axios.get(url).then(response => {
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }
            this.setState({ taskData: response.data.result });
        });
    }

    render() {
        if (this.state.redirectTo) {
            return <Navigate to={this.state.redirectTo} />
        }
        return (
            <div className="verticalStack flex" style={{height: "calc(100vh - 80px)", overflowY: "scroll"}}>
                <div className="horizontalStackCenter universalTableListingBar">
                    <div className="horizontalStackCenter onHoverToOrange clickable" onClick={() => this.setState({ redirectTo: -1 })}>
                        <img src={btn_back_gray} style={{height: 14, marginRight: 7}} />
                        <span className="fontPoppinsRegular13Gray" style={{whiteSpace: "nowrap"}}>{"Return to Previous Page"}</span>
                    </div>
                </div>

                <div className="horizontalStack flex">
                    <div className="verticalStack flex" style={{position: "relative"}}>

                        {/* APPLICATION TILE */}
                        <ApplicationTile />

                    </div>

                    <div className="verticalStack">

                        {/* TILE FOR APPLICATION HISTORY */}
                        <ApplicationHistoryTile />

                        {/* TILE FOR EDITING TASK */}
                        <div className={"universalAddTile"} style={{position: "relative", marginBottom: 20}}>

                            <div className="verticalStack">
                                <span className="fontPoppinsSemiBold15">Task</span>
                                <span className="fontPoppinsRegular13">Please decide about this application.</span>
                            </div>

                            <div style={{position: "relative", backgroundColor: "var(--lightest-gray)", marginTop: 10}}>

                                <div className="verticalStack" style={{paddingLeft: 20, paddingTop: 20, paddingRight: 25}}>
                                    <span className="fontPoppinsRegular13" style={{marginBottom: -5}}>Note:*</span>
                                    <textarea className="modalInputAddNote" rows="4" style={{backgroundColor: "white"}} placeholder="" id="textAreaNote" name="textAreaNote" value={this.state.note} onChange={e => this.setState({ note: e.target.value })}></textarea>
                                </div>

                                <div className="horizontalStack" style={{paddingLeft: 20, paddingTop: 20, paddingRight: 25, paddingBottom: 10}}>
                                    <RoundButton title={"Approve"} className={"roundButtonOrange"} onClick={this.editExistingRole} whiteText={true} />
                                    <RoundButton title={"Reject"} className={"roundButtonGray"} onClick={this.editExistingRole} whiteText={true} style={{marginLeft: 10}} />
                                </div>

                                <div className="horizontalStack" style={{paddingLeft: 20, paddingRight: 25, paddingBottom: 20}}>
                                    <RoundButton title={"Ask for more info"} className={"roundButtonGray"} onClick={this.editExistingRole} whiteText={true} />
                                </div>

                            </div>

                        </div>
                    </div>

                </div>
            </div>
        );
    }
}

const withLocation = Component => props => {
    const location = useLocation();

    return <Component {...props} location={location} />;
};

export default withLocation(TaskDetail);
